import { useQueryFilters } from '@cannect/hooks/utils/useQueryFilters'
import { useGetProductSubcategories } from '@cannect/services/resources/products'
import { useCallback, useMemo } from 'react'
import { DEFAULT_SUBCATEGORY_IMAGE, SUBCATEGORY_IMAGE_MAP } from './constants'
import { ISubcategoryCircle } from './types'

export const useSubcategoryCircles = () => {
  const { queryParams, updateQueryParams } = useQueryFilters<{ shopify_collection: string; class_id: string }>()
  const { data, isLoading, isError } = useGetProductSubcategories()

  const subcategories: ISubcategoryCircle[] = useMemo(
    () =>
      (data?.subcategories || []).map((subcategory) => ({
        ...subcategory,
        image: SUBCATEGORY_IMAGE_MAP[subcategory.handle] || DEFAULT_SUBCATEGORY_IMAGE
      })),
    [data]
  )

  const isSelectedSubcategory = useCallback(
    (subcategory: ISubcategoryCircle) => queryParams.get('shopify_collection') === subcategory.handle,
    [queryParams]
  )

  /**
   * A collection ja e o recorte da categoria, entao o `class_id` que trouxe o usuario ate aqui
   * (Medicamento = Alopatico) so estreita de novo — e em AND, escondendo produto que pertence a
   * collection mas nao aquela classe. Em dev: doencas-cronicas cai de 1897 para 1838, higiene-beleza
   * de 367 para 342, e perda-de-peso, cujo unico produto nao e alopatico, vai a zero.
   *
   * Por isso o clique limpa o `class_id`. Para a lista de circulos nao sumir junto, o
   * `ProductsListUI` passou a exibi-la tambem quando ha `shopify_collection` na URL.
   */
  const handleSubcategoryClick = useCallback(
    (subcategory: ISubcategoryCircle) => {
      updateQueryParams({ shopify_collection: subcategory.handle, class_id: null })
    },
    [updateQueryParams]
  )

  return {
    subcategories,
    isLoading,
    hasSubcategories: !isError && subcategories.length > 0,
    isSelectedSubcategory,
    handleSubcategoryClick
  }
}
